<template>
  <v-row>
    <!-- Start Single Portfolio  -->
    <v-col
      xl="3"
      lg="3"
      md="4"
      sm="6"
      cols="12"
      class="portfolio-tilthover"
      v-for="(item, i) in portfolioContent"
      :key="i"
    >
      <div class="im_portfolio">
        <div class="thumbnail_inner">
          <div class="thumbnail">
            <a :href="item.link">
              <img class="w-100" :src="item.src" alt="Portfolio Images" />
            </a>
          </div>
        </div>
        <div class="content">
          <div class="inner">
            <div class="portfolio_heading">
              <div class="category_list">
                <router-link :to="item.link">{{
                  item.category
                }}</router-link>
              </div>
              <h4 class="heading-title">
                <router-link :to="item.link">{{
                  item.title
                }}</router-link>
              </h4>
            </div>
            <div class="portfolio_hover">
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
        <router-link
          class="transparent_link"
          :to="item.link"
        ></router-link>
      </div>
    </v-col>
    <!-- End Single Portfolio  -->
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        portfolioContent: [
          {
            src: require("../../assets/images/portfolio/portfolio-10.png"),
            category: "Laravel/Vue.Js",
            title: "Project Management System",
            description: "A comprehensive project management system built with Laravel and Vue.js, providing a user-friendly interface for managing projects, tasks, and teams.",
            link: "/portfolio/pms-demo",
          },
          {
            src: require("../../assets/images/portfolio/portfolio-11.png"),
            category: "Laravel/Vue.Js",
            title: "Inventory With POS System",
            description: "A comprehensive inventory management system with POS functionality built with Laravel and Vue.js, providing a user-friendly interface for managing inventory, sales, and customers.",
            link: "/portfolio/inventory-with-pos",
          },
          {
            src: require("../../assets/images/portfolio/portfolio-08.png"),
            category: "Laravel/Vue.Js",
            title: "XFSDPH - Account Management System",
            description: "A comprehensive account management system built with Laravel and Vue.js, providing a user-friendly interface for managing accounts, transactions, and customers.",
            link: "/portfolio/xfsdph",
          },
        ],
      };
    },
  };
</script>
